/* jshint esversion: 6 */
/* jshint ignore:start */
import { useEffect, useContext, useState } from 'react';
import { MyContext } from '../../Context/MyProvider';
import axios from 'axios';
import { showTost } from '../../showTost';
import Razorpay from './RazorPay';
import Paypal from './Paypal';
import Stripe from './Stripe';
import FlutterWave from './FlutterWave';
import PayFast from './PayFast';
import PayStack from './PayStack';
import Midtrans from './Midtrans';
import KhaltiPayment from './KhaltiPayment';
import MercadoPago from './MercadoPago';
import CinetPay from './CinetPay';
import { useTranslation } from 'react-i18next';

const Payment = ({ Amount }) => {

    const { t } = useTranslation();

    const { BaseUrl, paymentLoad, setPaymentLod } = useContext(MyContext);

    const [paymentList, setPaymentList] = useState([]);
    const [selectPayment, setSelectPayment] = useState("");
    const [isPayment, setIsPayment] = useState(false);
    const [attributes, setAttributes] = useState();

    useEffect(() => {
        axios.post(`${BaseUrl}user_api/u_paymentgateway.php`)
            .then((res) => {
                console.log("u_paymentgateway", res);
                setPaymentList(res.data.paymentdata);
            })
            .catch((error) => {
                console.error("u_paymentgateway", error);
            });
    }, []);

    const HandleContinue = () => {

        if (paymentLoad) {
            showTost(t("Payment in Process !!"), "info");
            return;
        }

        if (!selectPayment) {
            showTost(t("Select Payment Method !!"), "error");
            return;
        }

        setIsPayment(true);
        setPaymentLod(true);
        sessionStorage.setItem("Paymentid", selectPayment);
    };

    return (
        <div>
            <div className="">
                <h1 className="font-bold text-[20px]">{t("Select Payment Method")}</h1>
                <div className="h-[450px] scroll-container">
                    {paymentList.length >= 1
                        ? paymentList.map((item, index) => {
                            return <div onClick={() => { setSelectPayment(item.id); setAttributes(item.attributes) }} key={index} className={`${selectPayment === item.id && "border-gray-900"} p-[15px] bg-[#E6E8EC] rounded-[10px] mt-[10px] cursor-pointer border-[1px] hover:border-gray-900`}>
                                <div className="flex items-center gap-[10px]">
                                    <img src={BaseUrl + item.img} className="w-[60px] h-[60px]" alt="" />
                                    <div className="">
                                        <h1 className="font-bold text-[16px] text-gray-700">{item.title}</h1>
                                        <p className="text-[14px] text-gray-500">{item.subtitle}</p>
                                    </div>
                                </div>
                            </div>
                        })
                        : <div className="h-[100%] flex items-center justify-center">
                            <h1>{t("Loading...")}</h1>
                        </div>}
                </div>
                <button onClick={HandleContinue} className="button"> {paymentLoad ? <span className="loader2 -mb-[5px]"></span> : "Continue"}</button>
            </div>

            {(isPayment && selectPayment === "4") && <Razorpay Amount={Amount} attributes={attributes} />}
            {(isPayment && selectPayment === "1") && <div onClick={() => { setSelectPayment(""); setIsPayment(false) }} id="BlockSection" className=" px-[15px] py-[15px] w-full h-full fixed top-0 left-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]">
                <div onClick={(e) => e.stopPropagation()} className="w-[20%]  max-_430_:w-[100%] max-_768_:w-[90%] max-_1030_:w-[50%] max-_1500_:w-[40%] bg-white rounded-[15px] p-[15px]">
                    <div className="flex flex-col justify-center items-center text-center">
                        <Paypal Amount={Amount} attributes={attributes} />
                    </div>
                </div>
            </div>}
            {(isPayment && selectPayment === "2") && <div onClick={() => { setSelectPayment(""); setIsPayment(false) }} id="BlockSection" className=" px-[15px] py-[15px] w-full h-full fixed top-0 left-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]">
                <div onClick={(e) => e.stopPropagation()} className="w-[20%]  max-_430_:w-[100%] max-_768_:w-[90%] max-_1030_:w-[50%] max-_1500_:w-[40%] bg-white rounded-[15px] p-[15px]">
                    <div className="flex flex-col justify-center items-center text-center">
                        <Stripe Amount={Amount} />
                    </div>
                </div>
            </div>}
            {(isPayment && selectPayment === "9") && <div onClick={() => { setSelectPayment(""); setIsPayment(false) }} id="BlockSection" className=" px-[15px] py-[15px] w-full h-full fixed top-0 left-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]">
                <div onClick={(e) => e.stopPropagation()} className="w-[20%]  max-_430_:w-[100%] max-_768_:w-[90%] max-_1030_:w-[50%] max-_1500_:w-[40%] bg-white rounded-[15px] p-[15px]">
                    <div className="flex flex-col justify-center items-center text-center">
                        <PayStack Amount={Amount} attributes={attributes} />
                    </div>
                </div>
            </div>}
            {(isPayment && selectPayment === "7") && <FlutterWave Amount={Amount} attributes={attributes} />}
            {(isPayment && selectPayment === "12") && <PayFast Amount={Amount} attributes={attributes} />}
            {(isPayment && selectPayment === "13") && <Midtrans Amount={Amount} />}
            {(isPayment && selectPayment === "15") && <KhaltiPayment Amount={Amount} />}
            {(isPayment && selectPayment === "16") && <MercadoPago Amount={Amount} />}
            {(isPayment && selectPayment === "17") && <CinetPay Amount={Amount} attributes={attributes} />}

        </div>
    )
}

export default Payment
/* jshint ignore:end */